module.exports = __webpack_public_path__ + "static/media/logo_green.7a34cf42.png";